module.exports = __webpack_public_path__ + "assets/ic_badge_03.688b4935.svg";